import { useEmbedded as useCalendarEmbedded } from "source/calendar/hooks/useEmbedded"
import { useChurchCenterIframe } from "./useChurchCenterIframe"

export function useEmbedded() {
  const { embedded: embeddedCalendar } = useCalendarEmbedded()
  const { inIframe } = useChurchCenterIframe()

  return embeddedCalendar || inIframe
}
